import { getAPI } from "../../../api/Networking";
import { LabelValue } from "../../../models/Dashboard/Analytics";
import { FinanceAnalyticsAPIFilters } from "../../../models/Dashboard/FinanceDashboard/FinanceAnalyticsFilters";

export default class FinanceAnalyticsDashboardAPI {
  getTatsData = async (
    url: string,
    filters: FinanceAnalyticsAPIFilters
  ): Promise<LabelValue[]> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.start_date)
        queryParams.append("start_date", filters.start_date);

      if (filters.end_date) queryParams.append("end_date", filters.end_date);

      if (filters.order_id && filters.order_id.length > 0) {
        queryParams.append(
          "order_id",
          filters.order_id.map((item) => item.id).join(",")
        );
      }
      if (filters.customer_id && filters.customer_id.length > 0) {
        queryParams.append(
          "customer_id",
          filters.customer_id.map((item) => item.id).join(",")
        );
      }

      const response = await getAPI(
        `/v5/finance-analytics${url}?${queryParams.toString()}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
